import { refs, domReady } from '../modules/utils.js';

class MoonPhase extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    // this.#listeners();
    this.moonPhase = this.calculateMoonPhase();
    this.#render();
  }

  #listeners() {
  }

  calculateMoonPhase(date = new Date()) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    let c, e, jd, b;

    if (month < 3) {
      year--;
      month += 12;
    }

    ++month;
    c = 365.25 * year;
    e = 30.6 * month;
    jd = c + e + day - 694039.09; // Julian day relative to Jan 1.5, 2000
    jd /= 29.5305882; // Divide by the Moon cycle
    b = parseInt(jd); // Integer part
    jd -= b; // Decimal part
    b = Math.round(jd * 8); // Scale fraction from 0-8 and round

    if (b >= 8) b = 0; // 0 and 8 are the same phase

    const phases = [
      'New Moon',
      'Waxing Crescent',
      'First Quarter',
      'Waxing Gibbous',
      'Full Moon',
      'Waning Gibbous',
      'Last Quarter',
      'Waning Crescent'
    ];

    return {
      phase: b,
      name: phases[b],
      fraction: jd,
      illumination: Math.abs(0.5 - jd) * 2 // 0 = new/full, 1 = quarter
    };
  }

  #render() {
    if (!this.moonPhase) return;
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' }).toUpperCase();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    this.refs.date.innerText = `${day} ${month} - ${hours}:${minutes}`;

    const phase = this.moonPhase.name;
    const itPhases = {
      'New Moon': 'Luna Nuova',
      'Waxing Crescent': 'Luna Crescente',
      'First Quarter': 'Luna Crescente',
      'Waxing Gibbous': 'Luna Crescente',
      'Full Moon': 'Luna Piena',
      'Waning Gibbous': 'Luna Calante',
      'Last Quarter': 'Luna Calante',
      'Waning Crescent': 'Luna Calante',
      'Dark Moon': 'Luna Nuova'
    };
    const enPhases = {
      'New Moon': 'New Moon',
      'Waxing Crescent': 'Crescent Moon',
      'First Quarter': 'Crescent Moon',
      'Waxing Gibbous': 'Crescent Moon',
      'Full Moon': 'Full Moon',
      'Waning Gibbous': 'Waning Moon',
      'Last Quarter': 'Waning Moon',
      'Waning Crescent': 'Waning Moon',
      'Dark Moon': 'New Moon'
    };

    if (Shopify?.locale == 'it') {
      this.refs.moonPhase.innerText = itPhases[phase] || phase;
    }
    else {
      this.refs.moonPhase.innerText = enPhases[phase] || phase;
    }
  }
}

customElements.define('moon-phase', MoonPhase);
